import { IHoliday } from '../../../shared/interfaces/holiday/IHoliday';
import { IBaseModel } from '../../../shared/interfaces/shared/IBase';
import { IPagination } from '../../../shared/interfaces/shared/IPagination';
import { requests } from '../../../utils/api/api.service';
import { HOLIDAY_URL } from '../../../utils/api/endpoints';

export const AdminHolidaysService = {
  get: (pagination: IPagination): Promise<IBaseModel<IHoliday[]>> =>
    requests.get(HOLIDAY_URL, pagination),
  getSingle: (id: number): Promise<IHoliday> =>
    requests.get(`${HOLIDAY_URL}/${id}`),
  create: (params: IHoliday) => requests.post(HOLIDAY_URL, params),
  update: (params: IHoliday, id: number) =>
    requests.put(`${HOLIDAY_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${HOLIDAY_URL}/${id}`),
};
